import { ServiceProvider } from 'providers/service/service';
// tslint:disable
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { AuthGuard } from './guards/auth.guard';
import { AuthService } from './login/auth.service';
import { LoginComponent } from './login/login.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { LocationStrategy, HashLocationStrategy, CommonModule } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { AppComponent } from './app.component';
registerLocaleData(localePt);

// Import containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent
} from './containers';

const APP_CONTAINERS = [
  FullLayoutComponent,
  SimpleLayoutComponent
]

// Import components
import {
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  APP_SIDEBAR_NAV
} from './components';

const APP_COMPONENTS = [
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  APP_SIDEBAR_NAV
]

// Import directives
import {
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES
} from './directives';

const APP_DIRECTIVES = [
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES
]

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { PipesModule } from 'pipes/pipes.module';
import { LottieAnimationViewModule } from 'ng-lottie';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore } from 'angularfire2/firestore';
import { ValidaCampoProvider } from 'providers/valida-campo/valida-campo';
import { ValidaCepProvider } from 'providers/valida-cep/valida-cep';
import { GetImagemProvider } from 'providers/getImagem/getImagem';
import { DirectivesModule } from 'directives/directives.module';
import { AngularFireModule } from 'angularfire2';
import { FirebaseConfig } from 'firebase/firebase.config';
import { SafePipe } from 'pipes/safe/safe.pipe';
import { GenProvider } from 'providers/gen/gen';
import { ConfigProvider } from 'providers/config/config';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { MessageService } from 'primeng/api';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {ProgressBarModule} from 'primeng/progressbar';
import { SharedModule } from './shared/shared.module';
import { FunctionsProvider } from 'providers/functions/functions';
import { MessagingService } from './messaging.service';
import { NgxVcardModule } from 'ngx-vcard';
@NgModule({
  imports: [
    NgxVcardModule,
    MessagesModule,
    MessageModule,
    ProgressSpinnerModule,
    ProgressBarModule,
    BrowserModule,
    BrowserAnimationsModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    CommonModule,
    AppRoutingModule,
    DirectivesModule,
    FormsModule,
    PipesModule,
    BrowserModule,
    HttpModule,
    SharedModule,
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    AngularFireModule.initializeApp(FirebaseConfig),
    LottieAnimationViewModule.forRoot()
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    ...APP_COMPONENTS,
    ...APP_DIRECTIVES,
    LoginComponent,
    FileUploadComponent,
    SafePipe
   ],
  providers: [
    MessageService,
    MessagingService,
    AuthService,
    AngularFireAuth,
    ModalModule,
    AngularFireDatabase,
    AuthGuard,
    GenProvider,
    ServiceProvider,
    ConfigProvider,
    FunctionsProvider,
    GetImagemProvider,
    ValidaCampoProvider,
    AngularFirestore,
    ValidaCepProvider,
    ValidaCampoProvider,
    {
      provide: LOCALE_ID,
      useValue:'pt-BR'//'en-EN'//'pt-BR'
    },{
    provide: LocationStrategy,
    useClass: HashLocationStrategy
  }],
  bootstrap: [ AppComponent ]


})
export class AppModule { }



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/app.module.ts